<img kendoButton (click)="exportGrid()" title="{{exportTitle}}" src="/assets/common/images/file-excel-2-2.svg" id="export-excel" />